import { render } from "./Umwandeln.vue?vue&type=template&id=1a8b64d6&scoped=true"
import script from "./Umwandeln.vue?vue&type=script&lang=js"
export * from "./Umwandeln.vue?vue&type=script&lang=js"

import "./Umwandeln.vue?vue&type=style&index=0&id=1a8b64d6&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8b64d6"]])

export default __exports__